module.exports = __webpack_public_path__ + "static/media/Banner-eng-2.4795cb67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/best-deals/Banner-eng-2.png
// module id = 1953
// module chunks = 0